<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>{{
        $t('INHABITANT_CHANGES.MANAGEMENT')
      }}</v-toolbar-title>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <v-row>
        <v-col cols="12">
          <v-col cols="12">
            <inhabitant-changes-list-filters @setFilters="setFilters" />
          </v-col>
        </v-col>
        <v-col cols="12">
          <inhabitant-changes-list
            :items="items"
            :meta="meta"
            :options.sync="options"
            @show="showInhabitantChange"
          />
        </v-col>
      </v-row>

      <v-dialog
        v-if="dialog"
        v-model="dialog"
        persistent
        width="unset"
        max-width="1200"
      >
        <request
          :id="inhabitantChange.id"
          :type="inhabitantChange.type_id"
          @cancel="cancelDialog"
          @updated="updateInhabitantChange"
        />
      </v-dialog>
    </v-sheet>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import InhabitantChangesList from '../components/InhabitantChangesList.vue';
import InhabitantChangesListFilters from '../components/InhabitantChangesListFilters.vue';
import errors from '@/modules/_global/mixins/errors';
import listOptions from '@/modules/_global/mixins/list-options';

export default {
  name: 'InhabitantChangesPage',

  components: {
    InhabitantChangesList,
    InhabitantChangesListFilters,
    Request: () => import('@/modules/inhabitant_changes/components/Request')
  },

  mixins: [errors, listOptions],

  data() {
    return {
      dialog: false,
      inhabitantChange: null,
      inhabitantChanges: []
    };
  },

  computed: {
    ...mapState('inhabitant_changes', ['paginationOptions'])
  },

  methods: {
    ...mapActions('inhabitant_changes', ['getItemsList']),

    showInhabitantChange(item) {
      this.inhabitantChange = item;
      this.dialog = true;
    },

    updateInhabitantChange() {
      this.cancelDialog();
      this.refreshData();
    },

    cancelDialog() {
      this.dialog = false;
      this.inhabitantChange = null;
    }
  }
};
</script>
